import { ContextsAPI } from "../../Tabs/Contexts/infrastructure";
import { IntentsAPI } from "../../Tabs/Intents/infrastructure";

const { showNotify } = require("vendor/application/disptach");
const { getIntentBody } = require("vendor/application");

export const fetchData = async ({
  dispatch,
  actualProject,
  access,
  t,
  updateContexts,
  updateIntent,
  limits,
  onNodesUpdate,
  handleTabs,
  history,
  i18n,
  location,
  staticContext,
  tReady,
  data,
  setParams,
  setNodes,
  setEdges,
  updateElement,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const intentId = urlParams.get("id");

  const intentsAPI = new IntentsAPI(actualProject.id, access, {
    id: intentId,
    t,
    actualProject,
    updateContexts,
    updateIntent,
    limits,
    access,
    onNodesUpdate,
    dispatch,
    handleTabs,
    history,
    i18n,
    location,
    staticContext,
    tReady,
    data,
    updateElement,
  });

  let intent;

  if (intentId) {
    try {
      intent = await intentsAPI.get_intent_by_id();
    } catch (err) {
      dispatch(showNotify({ message: err, severity: "error" }));
      return;
    }
  } else {
    intent = getIntentBody();
  }

  updateIntent(intent);
  const nodes = intent.nodes || [];
  const edges = intent.edges || [];
  if (nodes.length) setNodes(nodes);
  if (edges.length) setEdges(edges);

  const contextsAPI = new ContextsAPI(actualProject.id, access, {
    id: intentId,
    t,
    actualProject,
    updateContexts,
    updateIntent,
    limits,
    access,
    onNodesUpdate,
    dispatch,
    handleTabs,
    history,
    i18n,
    location,
    staticContext,
    tReady,
    data,
    updateElement,
  });
  const fetchedContexts = await contextsAPI.get_contexts();
  updateContexts(fetchedContexts);
  const entities = await intentsAPI.get_entities();
  const entityParams = entities.custom.concat(entities.system);
  setParams(entityParams);

  const updatedIntent = {
    ...intent,
    extensions: intent.extensions || {},
  };

  updateIntent(updatedIntent);
  setNodes((prevNodes) =>
    prevNodes.map((node) => ({
      ...node,
      data: {
        ...node.data,
      },
    }))
  );
};
